/*
 * @Descripttion: 
 * @Author: Niu Chenxin
 * @Date: 2020-12-02 09:20:20
 * @LastEditors: Niu Chenxin
 * @LastEditTime: 2021-01-05 10:32:23
 */
import Http from "./../http";
import appHttp from './../appHttp'

export default {
  // 获取所有专题及视频
  region(params, callback) {
    Http.get("/region/list", params, res => {
      callback(res);
    })
  },
  //活动提交申请接口POST
  UserSubmit(urlParams, params, callback, errorFn) {
    Http.post("/donate/create", urlParams, params, res => {
      callback(res);
    }, error => {
      errorFn();
    })
  },
  //活动提交申请接口POST
  uploadImages(img, urlParams, params, callback) {
    Http.post("/wechat/uploadImages?mediaId=" + img, urlParams, params, res => {
      callback(res);
    })
  },
  //活动提交申请接口POST
  countMember(urlParams, callback, errorFn) {
    Http.get("/donate/countMember", urlParams, res => {
      callback(res);
    }, error => {
      errorFn();
    })
  },
  //上传图片接口
  uploadImageServe(urlParams, params, callback) {
    Http.post("/donate/img", urlParams, params, res => {
      callback(res);
    })
  },
  // app端提交订单接口
  UserSubmitApp(urlParams, params, callback, errorFn) {
    appHttp.post("/donate/createh5", urlParams, params, res => {
      callback(res);
    }, error => {
      errorFn();
    })
  },
  // 查询用户提交信息内容
  searchUserInfo(urlParams, params, callback) {
    Http.post("/donate/getOrder", urlParams, params, res => {
      callback(res);
    })
  },
  // 用户订单确认接口
  userOrderConfirm(urlParams, params, callback) {
    Http.post("/donate/submit", urlParams, params, res => {
      callback(res);
    })
  },
  // 手机号绑定openid
  bindPhoneAndOpenId(urlParams, params, callback) {
    Http.post("/donate/findMyOrder", urlParams, params, res => {
      callback(res);
    })
  }
}